import styled, { css } from 'styled-components';
import {
  BlueColors,
  MediaQuery,
  NeutralColors,
  RedColors,
  Shadows,
} from 'theme';

interface ContainerProps {
  isOpen: boolean;
}

const Container = styled.div<ContainerProps>`
  position: fixed;
  right: 16px;
  top: 64px;
  width: 440px;
  max-height: 560px;
  background-color: ${NeutralColors[0]};
  border-radius: 16px;
  box-shadow: ${Shadows.Elevation1};
  z-index: 100;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  transition: all 0.3s ease-in-out;

  ${(props) =>
    !props.isOpen &&
    css`
      opacity: 0;
      visibility: hidden;
      transform: translateY(-8px);
    `}

  ${(props) =>
    props.isOpen &&
    css`
      opacity: 1;
      visibility: visible;
      transform: translateY(0);
    `}

  @media (max-width: ${MediaQuery.screenSizes.desktop}px) {
    width: calc(100% - 32px);
  }
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  gap: 8px;
`;

const Title = styled.h3`
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
  color: ${NeutralColors[100]};
  margin: 0;
`;

const MarkAllReadButton = styled.button`
  display: flex;
  align-items: center;
  gap: 4px;
  background: none;
  border: none;
  cursor: pointer;
  color: ${BlueColors[60]};
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  padding: 6px 8px 6px 4px;
  border-radius: 4px;

  &:hover {
    background-color: ${BlueColors[10]};
  }

  &:disabled {
    cursor: default;
    opacity: 0.6;
  }
`;

const TabsContainer = styled.div`
  display: flex;
  padding: 0 16px;
`;

const Tab = styled.button<{ isActive: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  height: 40px;
  padding: 8px 16px;
  background: none;
  border: none;
  border-bottom: 2px solid
    ${(props) => (props.isActive ? BlueColors[60] : 'transparent')};
  cursor: pointer;
  font-size: 16px;
  line-height: 24px;
  font-weight: ${(props) => (props.isActive ? 600 : 400)};
  color: ${(props) => (props.isActive ? BlueColors[60] : NeutralColors[70])};

  &:hover {
    color: ${BlueColors[60]};
  }
`;

const NotificationList = styled.div`
  padding: 16px 0;
  flex: 1;
  overflow-y: auto;
`;

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 99;
`;

const NotificationBadge = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${RedColors[50]};
`;

export {
  Container,
  Header,
  MarkAllReadButton,
  NotificationBadge,
  NotificationList,
  Overlay,
  Tab,
  TabsContainer,
  Title,
};
